export interface AssetsCookieCheck {
  /*🤫
🤫
🤫
🤫*/
  cookieCheck: {
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    track: (cookieName: string, isDeleted: boolean) => void;
    /*🤫
🤫
🤫
🤫
🤫*/
    run: () => void;
  };
}

/*🤫
🤫
🤫
🤫
🤫
🤫*/
export function track(cookieName: string, isDeleted: boolean): void {
  window.AS.RUM.sendCustomRequest("asset", {
    cookieName,
    isDeleted,
    breakpoint: window.o_global.device.breakpoint.getCurrentBreakpoint(),
    parentUrl: window.location.href,
  });
}

/*🤫
🤫
🤫
🤫
🤫*/
export function run(): void {
  let cookieDomain: string | undefined;

  const cookieArr = document.cookie.split(/;\s*/);
  const hostnameArr = window.location.hostname.split(".");
  const hostnameCount = hostnameArr.length;

  /*🤫*/
  /*🤫*/
  if (hostnameCount > 2) {
    cookieDomain = `.${hostnameArr.slice(hostnameCount - 2, hostnameCount).join(".")}`;
  }

  for (let i = 0; i < cookieArr.length; i += 1) {
    const cookieData = cookieArr[i].split(/=\s*/);

    if (cookieData.length > 1 && cookieData[1].length > 1024) {
      const cookieName = cookieData[0];

      /*🤫*/
      if (
        !!cookieDomain &&
        cookieDomain.split(".")[cookieDomain.split(".").length - 1].length < 2
      ) {
        cookieDomain = "";
      }
      /*🤫*/

      if (cookieDomain) {
        window.o_util.cookie.remove(cookieName, {
          domain: cookieDomain,
        });
      } else {
        window.o_util.cookie.remove(cookieName);
      }

      window.AS.cookieCheck.track(cookieName, !window.o_util.cookie.exists(cookieName));
    }
  }
}

/*🤫
🤫
🤫
🤫
🤫*/
window.AS.cookieCheck = { track, run };
window.o_global.eventLoader.onLoad(1000, run);
